import { render, staticRenderFns } from "./vpns.vue?vue&type=template&id=25add5e8"
import script from "./vpns.vue?vue&type=script&lang=js"
export * from "./vpns.vue?vue&type=script&lang=js"
import style0 from "./vpns.vue?vue&type=style&index=0&id=25add5e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports